import { fetchFolderDocuments } from './fetchFolderDocuments';

const getRevisionNumber = (revision) => parseInt(revision.split('-')[0]);

export const fetchAllActiveDocsInDivision = async (
  allDocs,
  fetchedFolders,
  folderOptions,
  accessToken,
  dispatch,
  updateFoldersLoaded
) => {
  const resultsObj = {};
  let updates = [];
  let fetchedFoldersCopy = { ...fetchedFolders };
  let promiseResults = await FolderDocsFetch(
    fetchedFoldersCopy,
    folderOptions,
    accessToken,
    dispatch,
    updateFoldersLoaded
  );

  const updateResultsObj = (doc) => {
    if (resultsObj[doc.id]) {
      // If a move happened, and duplicate doc exist, then we want the doc
      // with the latest revision
      if (
        getRevisionNumber(doc.doc._rev) >
        getRevisionNumber(resultsObj[doc.id].doc._rev)
      ) {
        resultsObj[doc.id] = doc;
      }
    } else {
      resultsObj[doc.id] = doc;
    }
  };

  allDocs.forEach((doc) => updateResultsObj(doc));

  await Promise.all(promiseResults).then((fetchResults) => {
    const newFolder = {};
    const archiveFetched = false;

    for (let i = 0; i < fetchResults.length; i++) {
      const folderIsInState = fetchedFoldersCopy[fetchResults[i].folderID];

      if (folderIsInState) {
        fetchedFoldersCopy[fetchResults[i].folderID].lastSeq =
          fetchResults[i].lastSequence;
        fetchResults[i].resultsArray.forEach((doc) => {
          const oldDocRev = resultsObj[doc.id] && resultsObj[doc.id].doc._rev;
          const newDocRev = doc.doc._rev;
          if (
            (oldDocRev &&
              newDocRev &&
              getRevisionNumber(newDocRev) > getRevisionNumber(oldDocRev)) ||
            !oldDocRev
          ) {
            resultsObj[doc.id] = doc;
          }
        });
        continue;
      }

      fetchResults[i].resultsArray.forEach((doc) => updateResultsObj(doc));

      if (fetchResults[i].updatesArray) {
        updates.push(...fetchResults[i].updatesArray);
      }
      newFolder[fetchResults[i].folderID] = {
        lastSeq: fetchResults[i].lastSequence,
        archiveFetched: archiveFetched,
      };
      Object.assign(fetchedFoldersCopy, newFolder);
    }
  });
  const results = FlattenAndRevisions(resultsObj, updates);
  return {
    results,
    fetchedFolders: fetchedFoldersCopy,
  };
};

const FolderDocsFetch = async (
  fetchedFoldersCopy,
  folderOptions,
  accessToken,
  dispatch,
  updateFoldersLoaded
) => {
  let folderCount = 0;
  let resultsArray = await Promise.all(
    folderOptions.map((id) => {
      return new Promise((resolve) => {
        const folderID = id.value;
        const folderIsInState = fetchedFoldersCopy[folderID];
        if (!folderIsInState) {
          fetchFolderDocuments(folderID, accessToken, dispatch, null, true).then(
            (res) => {
              folderCount += 1;
              updateFoldersLoaded(folderCount, dispatch);
              resolve(res);
            }
          );
        } else {
          const lastSeq = fetchedFoldersCopy[folderID].lastSeq;
          fetchFolderDocuments(folderID, accessToken, dispatch, lastSeq).then(
            (res) => {
              resolve(res);
            }
          );
        }
      });
    })
  );
  return resultsArray;
};

const FlattenAndRevisions = (resultsObj, updates) => {
  const results = { ...resultsObj };

  updates.forEach((doc) => {
    const oldDocRev = results[doc.id] && results[doc.id].doc._rev;
    const newDocRev = doc.doc._rev;

    if (
      (oldDocRev &&
        newDocRev &&
        getRevisionNumber(newDocRev) > getRevisionNumber(oldDocRev)) ||
      !oldDocRev
    ) {
      // If an update and the old document exists and it is of a higher
      // revision number, replace the document.
      results[doc.id] = doc;
    }
  });

  return Object.values(results);
};
